import { Logo } from '@components/layout/components/Logo'
import { ThemeChangeButton } from '@components/themeChangeButton/ThemeChangeButton'
import { ConfigProviderContext } from '@components/utils/config-provider'
import { SystemStatus } from '@features/system-status/components/SystemStatus'
import Language from '@mui/icons-material/Language'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const AuthHeader = () => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorElement)
  const { t, i18n } = useTranslation()
  const context = useContext(ConfigProviderContext)
  const headerText = `${context?.config?.companyName || ''} AI ${t('layout.header.title')}`

  useEffect(() => {
    document.title = headerText
  }, [headerText])

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorElement(null)
  }

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language)
    handleClose()
  }

  return (
    <Container maxWidth="xl">
      <Box
        display="flex"
        alignItems="center"
        alignContent="center"
        justifyContent="center"
        flexWrap="wrap"
      >
        <Box sx={{ flex: { xs: '1 100%', md: 1 }, justifyContent: 'center', width: { xs: '100%', md: 'auto' } }}>
          <Logo />
        </Box>
        <Box sx={{ flex: { xs: '1 100%', md: 1 }, justifyContent: 'center', width: { xs: '100%', md: 'auto' }, ml: 2 }}>
          <Typography sx={{ textAlign: { xs: 'center', md: 'left' } }}>{headerText}</Typography>
        </Box>
        <Box>
          <SystemStatus />
        </Box>
        <Box>
          <ThemeChangeButton />
        </Box>
        <Box>
          <Tooltip title={t('layout.header.switch_language.text')}>
            <IconButton
              aria-controls={open ? 'language-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <Language />
            </IconButton>
          </Tooltip>
          <Menu
            id="language-menu"
            anchorEl={anchorElement}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem
              selected={i18n.language === 'en'}
              onClick={() => handleLanguageChange('en')}
            >
              English
            </MenuItem>
            <MenuItem
              selected={i18n.language === 'pl'}
              onClick={() => handleLanguageChange('pl')}
            >
              Polski
            </MenuItem>
            <MenuItem
              selected={i18n.language === 'de'}
              onClick={() => handleLanguageChange('de')}
            >
              Deutsch
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Container>
  )
}
